import type { Cel } from '@/lib/poczekalnia-api';

/**
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 *  DO CZEGO PRZYPIĄĆ PACZKĘ WGRYWANĄ Z EKRANU KOPII.
 *
 *  ⚠️⚠️ POWSTAŁO Z BŁĘDU ZGŁOSZONEGO 09.09.2026 (Kamil): „mimo poprawek nie może wstawić pliku
 *  bak do proja bez agentów". Ekran wysyłał `wgrajDoPoczekalni({ rodzaj: 'WYSPA', groupId:
 *  groupId! })` — a w projekcie BEZ AGENTÓW nie ma wyspy, więc `groupId` jest `null`.
 *  Wykrzyknik uciszał TypeScript, a `URLSearchParams.set` zamieniał `null` na NAPIS `"null"`
 *  (tak samo `undefined` na `"undefined"`) — i API odrzucało żądanie zdaniem
 *  `groupId: Nieprawidłowy UUID`. ZMIERZONE: `nazwa=baza.bak&groupId=null` → `Invalid UUID`.
 *
 *  ⚠️⚠️ TO BYŁ JEDYNY PRZYPADEK, DLA KTÓREGO TA FUNKCJA POWSTAŁA. Poczekalnia istnieje po to,
 *  żeby kopię można było wgrać, „gdy wyspy jeszcze nie ma" — a nie dawało się tego zrobić
 *  dokładnie wtedy, gdy wyspy nie było. Ekran obiecywał („Kopię można już wgrać — poczeka na
 *  pierwszą maszynę") coś, czego nie umiał.
 *
 *  ⚠️⚠️ DLATEGO REGUŁA JEST TU, A NIE JAKO `groupId!` W WYWOŁANIU. Wejściem jest `string | null`,
 *  a wyjściem `Cel`, więc **nie da się** zbudować celu `WYSPA` bez identyfikatora — pomyłka,
 *  która wcześniej przechodziła przez `tsc` bez słowa, przestaje być wyrażalna. Sam `if` w
 *  komponencie znów dałby się uciszyć wykrzyknikiem przy następnej zmianie.
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 */
export function celWgrania(groupId: string | null): Cel {
  /**
   * ⚠️ BRAK WYSPY TO PÓŁKA, NIE BŁĄD. Paczka leży wtedy na wspólnej półce klienta i pojawi się
   * na ekranie kopii pierwszej wyspy, jaka powstanie — o to w tej funkcji chodzi. Rzucanie tu
   * wyjątkiem odebrałoby poczekalni jej jedyny powód istnienia.
   */
  if (groupId === null) return { rodzaj: 'POLKA' };
  return { rodzaj: 'WYSPA', groupId };
}
